import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-no-hole-message',
  templateUrl: './no-hole-message.component.html',
  styleUrls: ['./no-hole-message.component.scss']
})
export class NoHoleMessageComponent implements OnInit {
  @Input() data : any;
  @Output() closeWarningPopup = new EventEmitter<void>();

  constructor() {}

  ngOnInit(): void {}

  closeWarning() {
    this.closeWarningPopup.emit()
  }

}
